import { render, staticRenderFns } from "./LeaveRequested.vue?vue&type=template&id=214527a0"
import script from "./LeaveRequested.vue?vue&type=script&lang=js"
export * from "./LeaveRequested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports